import BudgetCountyPracticeWorkspace from "components/Budget/BudgetCountyPracticeWorkspace";
import BudgetListWorkspace from "components/Budget/BudgetListWorkspace";
import BudgetWorkspace from "components/Budget/BudgetWorkspace";
import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";

export const budgetRoutes = [
  {
    path: "/budget",
    element: <RouteLayout />,
    children: [{ index: true, element: <BudgetListWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Budget" />,
  },
  {
    path: "/budget/:budget_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <BudgetWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Budget" />,
  },
  {
    path: "/budget/:budget_id/:budget_county_practice_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <BudgetCountyPracticeWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Budget" />,
  },
];
